<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import { mapGetters, mapActions } from "vuex";
import {
  required,
  requiredIf,
  minLength,
  maxLength,
  helpers,
} from "vuelidate/lib/validators";
import DropzonePopup from "../../../components/widgets/dropzone-popup";
import { error_message, success_message } from "../../../state/helpers";
const mobileNumberValidator = helpers.regex(
  "alphaNumAndDot",
  /^(\+\d{1,3}[- ]?)?\d{10}$/
);
const specialCharNotAllowValidator = helpers.regex("alphaNumAndDot", /^[a-z\d.]*$/i);
export default {
  page: {
    title: "Admin Profile",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: { Layout, DropzonePopup },
  computed: mapGetters("user", ["userData", "getAllSetting"]),
  data() {
    return {
      form: {
        first_name: "",
        last_name: "",
        email: "",
        id: "",
        image: "",
        role: "Admin",
        mobile_number: "",
      },
      settings: {
        minimun_wallet_withdraw_amount: "0",
        pre_auth_charge_amount: "10",
        default_booking_time: "10",
        maximum_booking_time: "20",
        admin_mobile_number: "",
        admin_whatsapp_number: "",
        about_us_url: "",
        charger_efficency: "3.2",
      },
      profile_image: "",
      profile_image_path: "",
      profile_image_delete_url: process.env.VUE_APP_APIURL + "delete-admin-image",
    };
  },
  validations: {
    form: {
      first_name: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(20),
        specialCharNotAllowValidator,
      },
      last_name: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(20),
        specialCharNotAllowValidator,
      },
      email: {
        required,
      },
      mobile_number: {
        required,
        minLength: minLength(10),
        maxLength: maxLength(13),
        mobileNumberValidator,
      },
      image: {
        required: requiredIf(function () {
          return !(!!this.profile_image || !!this.form.image);
        }),
      },
    },
  },
  mounted() {
    this.getSettings();
    this.getUserDetail();
  },
  methods: {
    ...mapActions("user", ["getUser", "updateUser", "getSetting"]),

    onUserImagedeleted() {
      this.profile_image = "";
    },

    async getUserDetail() {
      let id = this.$route.params.id;
      await this.getUser({ id: id }).then((response) => {
        //console.log('response',response);
        const { id, first_name, last_name, email, mobile_number } = response.data.result;
        this.profile_image_path = response.data.result.admin_profile_image_path;
        this.profile_image = response.data.result.profile_image;
        this.id = response.data.result.id;
        this.form = { id, first_name, last_name, email, mobile_number };
        setTimeout(() => {
          if (this.getAllSetting.length > 0) {
            this.settings.minimun_wallet_withdraw_amount = this.getAllSetting[0].updated_value;
            this.settings.pre_auth_charge_amount = this.getAllSetting[1].updated_value;
            this.settings.default_booking_time = this.getAllSetting[2].updated_value;
            this.settings.maximum_booking_time = this.getAllSetting[3].updated_value;
            this.settings.admin_mobile_number = this.getAllSetting[4].updated_value;
            this.settings.admin_whatsapp_number = this.getAllSetting[5].updated_value;
            this.settings.about_us_url = this.getAllSetting[6].updated_value;
            this.settings.charger_efficency = this.getAllSetting[7].updated_value;
            // this.settings.minimun_wallet_withdraw_amount = this.getAllSetting[0].updated_value;
            // this.settings.default_booking_time = this.getAllSetting[1].updated_value;
            // this.settings.pre_auth_charge_amount = this.getAllSetting[2].updated_value;
            // this.settings.admin_mobile_number = this.getAllSetting[3].updated_value;
            // this.settings.admin_whatsapp_number = this.getAllSetting[4].updated_value;
            // this.settings.about_us_url = this.getAllSetting[5].updated_value;
            // this.settings.charger_efficency = this.getAllSetting[6].updated_value;
            // this.settings.maximum_booking_time = this.getAllSetting[7].updated_value;
            // this.getAllSetting.forEach((value, index) => {
            //   console.log(index);
            //   console.log(value);

            //   this.settings.minimun_wallet_withdraw_amount = value[index].updated_value;

            //   this.settings.default_booking_time = value[index].updated_value;
            // });
          }
        }, 2000);
      });
    },
    async getSettings() {
      await this.getSetting();
    },

    profileInIt() {
      this.$v.$touch();
      if (this.$v.form.$invalid) {
        return;
      } else {
        const fd = new FormData();
        fd.append("id", this.form.id);
        fd.append("first_name", this.form.first_name);
        fd.append("last_name", this.form.last_name);
        fd.append("email", this.form.email);
        fd.append("status", this.form.status);
        fd.append("mobile_number", this.form.mobile_number);
        fd.append("role", "Admin");
        fd.append("settings", JSON.stringify(this.settings));
        console.log("this.user.image", this.form.image);
        if (this.form.image) {
          fd.append("image", this.form.image);
        }
        this.updateUser(fd).then((response) => {
          if (response.data.code === 200) {
            localStorage.setItem(
              "user_name",
              JSON.stringify(response.data.result.full_name)
            );
            success_message(response.data.msg);
            this.$router.push({ name: "default" });
          } else {
            error_message(response.data.msg);
          }
        });
      }
    },
  },
};
</script>
<template>
  <Layout>
    <div class="row">
      <div class="col-12 mt">
        <div class="page-title-box d-flex align-items-center justify-content-between">
          <div class="page-title-left avatar-main-icon d-flex align-items-center">
            <div class="avatar-xs mr-3">
              <span
                class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18"
              >
                <i class="bx bx-user-circle"></i>
              </span>
            </div>
            <div class="margin-top report-tag">
              <h4 class="mb-0 font-size-18">
                {{ form.first_name }} {{ form.last_name }}
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <b-form @submit.prevent="profileInIt">
          <!-- user Info Start -->
          <div class="card">
            <div class="card-body">
              <h4 class="card-title">Personal Details</h4>
              <p class="card-title-desc"></p>
              <div class="row">
                <div class="form-group">
                  <input
                    id="id"
                    name="id"
                    type="hidden"
                    @id="form.id"
                    v-model="form.id"
                    class="form-control"
                  />
                </div>
                <div class="col-sm-6">
                  <b-form-group
                    id="input-group-1"
                    label="First Name"
                    label-for="first_name"
                    label-class="required"
                  >
                    <b-form-input
                      id="first_name"
                      name="first_name"
                      v-model="$v.form.first_name.$model"
                      type="text"
                      placeholder="First Name"
                      :class="{ 'is-invalid': $v.form.first_name.$error }"
                    ></b-form-input>
                    <div v-if="$v.form.first_name.$error" class="invalid-feedback">
                      <span v-if="!$v.form.first_name.required"
                        >First name is required.</span
                      >
                      <span v-if="!$v.form.first_name.minLength"
                        >Please enter first name minimum 3 character</span
                      >
                      <span v-if="!$v.form.first_name.maxLength"
                        >Please enter first name maximum 20 character</span
                      >
                      <span v-if="!$v.form.first_name.specialCharNotAllowValidator"
                        >Special character not allowed</span
                      >
                    </div>
                  </b-form-group>
                </div>

                <div class="col-sm-6">
                  <b-form-group
                    id="input-group-1"
                    label="Last Name"
                    label-for="last_name"
                    label-class="required"
                  >
                    <b-form-input
                      id="last_name"
                      name="last_name"
                      v-model="$v.form.last_name.$model"
                      type="text"
                      placeholder="Last Name"
                      :class="{ 'is-invalid': $v.form.last_name.$error }"
                    ></b-form-input>
                    <div v-if="$v.form.last_name.$error" class="invalid-feedback">
                      <span v-if="!$v.form.last_name.required"
                        >Last name is required.</span
                      >
                      <span v-if="!$v.form.last_name.minLength"
                        >Please enter last name minimum 3 character</span
                      >
                      <span v-if="!$v.form.last_name.maxLength"
                        >Please enter last name maximum 20 character</span
                      >
                      <span v-if="!$v.form.last_name.specialCharNotAllowValidator"
                        >Special character not allowed</span
                      >
                    </div>
                  </b-form-group>
                </div>

                <div class="col-sm-6">
                  <b-form-group
                    id="input-group-1"
                    label="Email"
                    label-for="email"
                    label-class="required"
                  >
                    <b-form-input
                      id="email"
                      name="email"
                      v-model="$v.form.email.$model"
                      type="text"
                      placeholder="Email"
                      :class="{ 'is-invalid': $v.form.email.$error }"
                    ></b-form-input>
                    <div v-if="$v.form.email.$error" class="invalid-feedback">
                      <span v-if="!$v.form.email.required">Email is required.</span>
                    </div>
                  </b-form-group>
                </div>
                <div class="col-sm-6">
                  <b-form-group
                    id="input-group-1"
                    label="Mobile Number [Use (+91)]"
                    label-for="mobile_number"
                    label-class="required"
                  >
                    <b-form-input
                      id="mobile_number"
                      name="mobile_number"
                      v-model="$v.form.mobile_number.$model"
                      type="text"
                      placeholder="Mobile Number"
                      :class="{ 'is-invalid': $v.form.mobile_number.$error }"
                    ></b-form-input>
                    <div v-if="$v.form.mobile_number.$error" class="invalid-feedback">
                      <span v-if="!$v.form.mobile_number.required"
                        >Mobile Number is required.</span
                      >
                      <span v-if="!$v.form.mobile_number.minLength"
                        >Please enter minimum 10 digit</span
                      >
                      <span v-if="!$v.form.mobile_number.maxLength"
                        >Please enter maximum 12 digit</span
                      >
                      <span v-if="!$v.form.mobile_number.mobileNumberValidator"
                        >Format is not correct or special character not allowed</span
                      >
                    </div>
                  </b-form-group>
                </div>
              </div>
            </div>
          </div>
          <!-- user Info End -->

          <!-- Setting Info Start -->
          <div class="card">
            <div class="card-body">
              <h4 class="card-title">Settings</h4>
              <p class="card-title-desc"></p>
              <div class="row">
                <div class="form-group">
                  <input
                    id="id"
                    name="id"
                    type="hidden"
                    @id="form.id"
                    v-model="form.id"
                    class="form-control"
                  />
                </div>
                <div class="col-sm-6">
                  <b-form-group
                    id="input-group-1"
                    label="Minimum Wallet Withdraw Amount"
                    label-for="minimun_wallet_withdraw_amount"
                    label-class="required"
                  >
                    <b-form-input
                      id="minimun_wallet_withdraw_amount"
                      name="minimun_wallet_withdraw_amount"
                      v-model="settings.minimun_wallet_withdraw_amount"
                      type="number"
                      placeholder="Minimun Wallet Amount"
                    ></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-sm-6">
                  <b-form-group
                    id="input-group-1"
                    label="Pre Auth Charge (Rs/minute)"
                    label-for="pre_auth_charge_amount"
                    label-class="required"
                  >
                    <b-form-input
                      id="pre_auth_charge_amount"
                      name="pre_auth_charge_amount"
                      v-model="settings.pre_auth_charge_amount"
                      type="text"
                      placeholder="Pre Auth Charge Amount"
                    ></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-sm-6">
                  <b-form-group
                    id="input-group-1"
                    label="Minimum Charging Booking Time (Minutes)"
                    label-for="default_booking_time"
                    label-class="required"
                  >
                    <b-form-input
                      id="minimun_wallet_withdraw_amount"
                      name="minimun_wallet_withdraw_amount"
                      v-model="settings.default_booking_time"
                      type="number"
                      placeholder="Minimun Wallet Amount"
                    ></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-sm-6">
                  <b-form-group
                    id="input-group-1"
                    label="Maximun Charging Booking Time (Minutes)"
                    label-for="default_booking_time"
                    label-class="required"
                  >
                    <b-form-input
                      id="maximum_wallet_withdraw_amount"
                      name="maximum_wallet_withdraw_amount"
                      v-model="settings.maximum_booking_time"
                      type="number"
                      placeholder="Maximum Wallet Amount"
                    ></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-sm-6">
                  <b-form-group
                    id="input-group-1"
                    label="Admin Mobile Number"
                    label-for="label_mobile_number"
                    label-class="required"
                  >
                    <b-form-input
                      id="admin_mobile_number"
                      name="admin_mobile_number"
                      v-model="settings.admin_mobile_number"
                      type="number"
                      placeholder="Admin Mobile Number"
                    ></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-sm-6">
                  <b-form-group
                    id="input-group-1"
                    label="Admin Whatsapp Number"
                    label-for="label_whatsapp_number"
                    label-class="required"
                  >
                    <b-form-input
                      id="admin_whatsapp_number"
                      name="admin_whatsapp_number"
                      v-model="settings.admin_whatsapp_number"
                      type="number"
                      placeholder="Admin Whatsapp Number"
                    ></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-sm-6">
                  <b-form-group
                    id="input-group-1"
                    label="About-Us URL"
                    label-for="label_about_us_url"
                    label-class="required"
                  >
                    <b-form-input
                      id="about_us_url"
                      name="about_us_url"
                      v-model="settings.about_us_url"
                      type="text"
                      placeholder="About-Us URL"
                    ></b-form-input>
                  </b-form-group>
                </div>
                <!-- charger efficency -->
                <div class="col-sm-6">
                  <b-form-group
                    id="input-group-1"
                    label="Charger Efficency"
                    label-for="label_charger_efficency"
                    label-class="required"
                  >
                    <b-form-input
                      id="charger_efficency"
                      name="charger_efficency"
                      v-model="settings.charger_efficency"
                      type="text"
                      placeholder="Charger Efficency"
                    ></b-form-input>
                  </b-form-group>
                </div>
                <!-- charger efficency -->
              </div>
            </div>
          </div>
          <!-- Setting Info End -->

          <!-- user Image Start -->
          <div class="card">
            <div class="card-body">
              <h4 class="card-title required">Image</h4>
              <p class="card-title-desc"></p>

              <div class="row">
                <div class="col-sm-3">
                  <dropzone-popup
                    type="file"
                    v-model="form.image"
                    id="profile_image"
                    acceptedFiles=".jpeg,.jpg,.png"
                    :editable-images="profile_image"
                    :media-path="profile_image_path + 'original'"
                    :delete-path="profile_image_delete_url"
                    @image-deleted="this.onUserImagedeleted"
                  />
                  <div v-if="$v.form.image.$error" class="invalid-feedback cuisine-img">
                    <span v-if="!$v.form.image.required">Image is required.</span>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-6">
                  <button class="btn btn-primary mr-1 mt-3">Update</button>
                  <b-button
                    @click="$router.go(-1)"
                    type="button"
                    variant="secondary"
                    class="mt-3"
                    >Cancel</b-button
                  >
                </div>
              </div>
            </div>
          </div>
          <!-- user Image End -->
        </b-form>
      </div>
    </div>
  </Layout>
</template>
<style>
.margin-top {
  margin-top: -20px;
}
.mt {
  margin-top: 15px;
}
</style>
